var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import isEqual from "../../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isEqual.js";
function isPathComplete(options, path) {
  var _a;
  if (path.length === 0)
    return !1;
  let currentOptions = options;
  for (const value of path) {
    const option = currentOptions.find((opt) => isEqual(opt.value, value));
    if (!option)
      return !1;
    if ((_a = option.children) != null && _a.length)
      currentOptions = option.children;
    else
      return !0;
  }
  return !1;
}
__name(isPathComplete, "isPathComplete");
function getSelectedOptions(propsOptions, path) {
  const options = [];
  let currentOptions = propsOptions;
  for (const value of path) {
    const option = currentOptions.find((opt) => isEqual(opt.value, value));
    if (option)
      options.push(option), currentOptions = option.children || [];
    else
      break;
  }
  return options;
}
__name(getSelectedOptions, "getSelectedOptions");
function getSelectedOptionsBrothers(propsOptions, path, notAllowed) {
  const _notAllowed = notAllowed ?? (() => !1), options = [];
  let currentOptions = propsOptions.filter((o) => !(_notAllowed(o, [o.value]) || o.disabled)), result;
  for (let i = 0; i < path.length; i++) {
    const value = path[i], optionIndex = currentOptions.findIndex((opt) => isEqual(opt.value, value)), option = optionIndex >= 0 ? currentOptions[optionIndex] : void 0;
    if (option) {
      if (options.push(option), i === path.length - 1) {
        let beforeIndex = optionIndex - 1, afterIndex = optionIndex + 1;
        beforeIndex = beforeIndex < 0 ? currentOptions.length - 1 : beforeIndex, afterIndex = afterIndex >= currentOptions.length ? 0 : afterIndex, result = {
          before: currentOptions[beforeIndex],
          after: currentOptions[afterIndex],
          columnIndex: options.length - 1
        };
      }
      const optionsPath = options.map((o) => o.value);
      currentOptions = (option.children || []).filter((o) => !(_notAllowed(o, [...optionsPath, o.value]) || o.disabled));
    } else
      break;
  }
  return result;
}
__name(getSelectedOptionsBrothers, "getSelectedOptionsBrothers");
export {
  getSelectedOptions,
  getSelectedOptionsBrothers,
  isPathComplete
};
//# sourceMappingURL=utils.js.map
